import type { Effect, Reducer, Subscription } from 'umi';
import { getDvaApp } from 'umi';
import { venuesSet } from '@/components/Searches/hooks';
import { getTokens } from '@/components/Searches/Searches';
import { getTechGraphNodeById } from '@/services/analysis';
import { getSearchRecordById } from '@/services/authorized';
import { GetContactOur } from '@/services/home';
import { renameKeys, uuid } from '@/utils';

export interface IndexModelState {
  theProjectInfo: any;
  searcher: string;
  searcherLoading: boolean;
  trendSettingInit?: any;
  setting?: {
    searcher: string;
    start_year?: number | string;
    end_year?: number | string;
  };
  filterStates: Record<string, any>;
  ContactOur?: Res.GetContactOur['data'];
}

export interface IndexModelType {
  namespace: 'trend';
  state: IndexModelState;
  effects: {
    query: Effect;
    getRealLabel: Effect;
    getRealSearches: Effect;
    GetContactOur: Effect;
  };
  reducers: {
    save: Reducer<IndexModelState>;
    // 启用 immer 之后
    // save: ImmerReducer<IndexModelState>;
  };
  subscriptions: {
    setup: Subscription;
    setup2: Subscription;
    setupAnalysis: Subscription;
    listToAnalysis: Subscription;
  };
}

const TrendModel: IndexModelType = {
  namespace: 'trend',

  state: {
    theProjectInfo: null,
    searcher: '',
    searcherLoading: true,
    trendSettingInit: undefined,
    setting: undefined,
    filterStates: {},
    ContactOur: undefined,
  },

  effects: {
    *query({ payload }, { call, put }) {},
    *getRealLabel({ payload }, { call, put }) {
      const { id, tree_id } = payload;
      const res = yield call(getTechGraphNodeById, id, tree_id);
      if (res.code == 200) {
        yield put({
          type: 'save',
          payload: {
            searcher: res.data.realSearches || res.data.searches,
            searcherLoading: false,
          },
        });
        return res;
      } else {
        return '';
      }
    },

    *getRealSearches({ payload }, { call, put }) {
      const id = payload;
      const res = yield call(getSearchRecordById, id);
      yield put({
        type: 'save',
        payload: { searcher: res.searches, searcherLoading: false },
      });
      return res;
    },
    // 获取商务信息
    *GetContactOur({ payload }, { call, put }) {
      const res = yield call(GetContactOur);
      if (res?.code === 200) yield put({ type: 'save', payload: { ContactOur: res.data } });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    saveFilterStates(state, action) {
      return {
        ...state,
        filterStates: {
          ...state.filterStates,
          ...action.payload,
        },
      };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      dispatch({ type: 'GetContactOur' });
      return history.listen((location) => {
        // 当前页面滚动条制定
        requestAnimationFrame(() => {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        });

        const { query = {} } = location as unknown as { query: Record<string, string> };
        // r这里是技术树跳转的id p是技术树的树id
        let { searcher, s, r, p } = query;
        if (r && !p) {
          r = window.atob(r);
        }

        if (!isNaN(+r)) {
          // const _srecord = sessionStorage.getItem('srecord');
          const _srecord = '';
          if (_srecord) {
            const srecord = JSON.parse(_srecord);
            dispatch({
              type: 'save',
              payload: {
                searcher: srecord.searches,
                searcherLoading: false,
              },
            });
            return;
          }
          dispatch({ type: 'save', payload: { searcherLoading: true } });
          dispatch({ type: 'getRealSearches', payload: +r });
        } else if (r) {
          dispatch({ type: 'save', payload: { searcherLoading: true } });
          dispatch({ type: 'getRealLabel', payload: { id: r, tree_id: p } });
        } else {
          dispatch({ type: 'save', payload: { searcher: searcher || s, searcherLoading: false } });
        }
      });
    },
    setup2({ history, dispatch }) {
      if (!history.location.pathname.includes('list')) return;
      try {
        let trendSetting = JSON.parse(sessionStorage.getItem('trendSetting'));
        sessionStorage.removeItem('trendSetting');
        dispatch({
          type: 'save',
          payload: {
            setting: trendSetting,
            filterStates: {
              // 论文
              paper: trendSetting,
              // 学者
              scholar: renameKeys(trendSetting, {
                countrys: 'author_countries',
                orgs: 'author_orgs',
              }),
              // 机构
              org: renameKeys(trendSetting, {
                countrys: 'org_countries',
              }),
            },
            trendSettingInit: {
              // 论文
              paper: trendSetting,
              // 学者
              scholar: renameKeys(trendSetting, {
                countrys: 'author_countries',
                orgs: 'author_orgs',
              }),
              // 机构
              org: renameKeys(trendSetting, {
                countrys: 'org_countries',
              }),
            },
          },
        });
      } catch (error) {}
      history.listen((location) => {
        if (location.pathname.includes('/list')) return;
        sessionStorage.removeItem('trendSetting');
        dispatch({
          type: 'save',
          payload: {
            setting: undefined,
            filterStates: {},
          },
        });
      });
    },
    setupAnalysis({ history, dispatch }) {
      history.listen((location) => {
        if (!location.pathname.includes('/ana')) return;
        dispatch({ type: 'save', payload: { setting: undefined } });
      });
    },
    listToAnalysis({ history, dispatch }) {
      return history.listen(() => {
        if (!history.location.pathname.includes('ana')) return;
        let trendSetting = {};
        try {
          trendSetting = JSON.parse(sessionStorage.getItem('list-to-analysis') || '{}') || {};
        } catch (error) {
          console.log('trendSetting list-to-analysis', error);
        }
        dispatch({ type: 'save', payload: { setting: trendSetting } });
        dispatch({ type: 'saveFilterStates', payload: { paper: trendSetting } });
        sessionStorage.removeItem('list-to-analysis');
      });
    },
    advancedSearch({ history, dispatch }) {
      if (!window.name) {
        const windowname = sessionStorage.getItem('customWindowName');
        window.name = windowname || uuid();
        sessionStorage.removeItem('customWindowName');
      }
      history.listen((location) => {
        if (location.pathname.includes('/advancedsearch')) {
        } else {
          sessionStorage.removeItem(window.name + 'advancedsearch');
        }
      });
    },
    cacheSetting({ dispatch }) {
      window.addEventListener('beforeunload', () => {
        const { setting, filterStates, trendSettingInit } = getDvaApp()._store.getState().trend;
        sessionStorage.setItem(
          'setting_filterStates_2024',
          JSON.stringify({ setting, filterStates, trendSettingInit }),
        );
      });

      try {
        let cacheSetting = sessionStorage.getItem('setting_filterStates_2024');
        sessionStorage.removeItem('setting_filterStates_2024');
        cacheSetting = JSON.parse(cacheSetting);
        dispatch({ type: 'save', payload: cacheSetting });
      } catch (error) {}
    },
  },
};
export default TrendModel;
